import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ShopOrderBatchesView } from "src/components/views/erp/production/shopOrderBatch/ShopOrderBatchesView.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/production/shopOrderBatches")({
	staticData: { title: i18n.t("shop_order_batches"), legacyViewKey: "shopOrderBatchesView" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <ShopOrderBatchesView isActive={isActive} />;
}
